import React from 'react';
import { useLocation } from 'react-router-dom';
import '../assets/css/pagewrapper.css'
import {show} from '../constants/countries.override'

/*const NavBarComponent = show
  ? React.lazy(() => import('./NavBarAfrec'))
  : React.lazy(() => import('./NavBar'));

const SlideComponent = show
  ? React.lazy(() => import('./SlideAfrec'))
  : React.lazy(() => import('./Slide'));
*/
  const navbarComponents = {
    afrec: React.lazy(() => import('./NavBarAfrec')),
    niger: React.lazy(() => import('./NavBar')),
  };

  const SlideComponents = {
    afrec: React.lazy(() => import('./SlideAfrec')),
    niger: React.lazy(() => import('./Slide')),
  };


  const NavBarComponent = navbarComponents[show ? 'afrec' : 'niger'];
  const SlideComponent = SlideComponents[show ? 'afrec' : 'niger'];

const PageWrapper = (props) => {
    const location = useLocation();
    // when `show` is true we add a class that switches the color palette via CSS
    const themeClass = show ? 'afrec-theme' : '';

    // Exemple : la page d'accueil = "/"
    const isHome = location.pathname === '/';

    return (
    <div className={`wrapper ${themeClass}`}>
            <NavBarComponent />
            {isHome && <SlideComponent />}
            <div className={props.className ? `page-body  ${props.className}` : 'page-body'}>
                {props.children}
            </div>
        </div>
    );
};


export default PageWrapper;